import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import NewMessageImage from '../NewMessageImage';
import Button from '../Button';
import Input from '../Input';
import Textarea from '../Textarea';
import { noopEvent } from '../../utils/helpers';

export default class NewMessage extends PureComponent {
  static propTypes = {
    onBlur: PropTypes.func,
  };

  static defaultProps = {
    onBlur: () => {},
  };

  handleFileDrop = event => {
    const { addImages } = this.props;
    if (event.dataTransfer.files) {
      event.preventDefault();
      addImages(event.dataTransfer);
    }
  };

  handleBlur = event => {
    const { chatId, onBlur } = this.props;
    onBlur({ id: chatId, text: event.target.value });
  };

  render() {
    const { message, update, send, chatId, role, addImages, removeImage } = this.props;
    return (
      <div className="chat-messenger">
        <label className="chat-messenger_uploader">
          <Input
            className="chat-messenger_uploader-input"
            type="file"
            onChange={e => addImages(e.target)}
            multiple="multiple"
          />
        </label>
        <div
          className="chat-messenger_message-container"
          onDragOver={noopEvent}
          onDrop={this.handleFileDrop}
        >
          <div className="chat-messenger_message-textarea-wrapper">
            <Textarea
              className="chat-messenger_message-textarea"
              placeholder="Type"
              rows={4}
              minRows={1}
              maxRows={9}
              value={message.text}
              autoFocus={true}
              onChange={e => update(e.target.value)}
              onBlur={this.handleBlur}
            />
          </div>
          <div className="chat-messenger_images-wrapper">
            {message.images.map((i, idx) => (
              <NewMessageImage key={idx} image={i} remove={() => removeImage(idx)} />
            ))}
          </div>
        </div>
        {message.error && <div className="chat-messenger_submit_error">An Error occurred</div>}
        <div>
          <Button
            className={`chat-messenger_submit ${message.sending ? '-in-progress' : ''}`}
            onClick={() => send(chatId, message, role)}
          >
            Send
          </Button>
          {message.sending &&
            message.files &&
            message.files.length > 0 && (
              <div className={'progressBarWrapper'}>
                <div className={'progressBar'} style={{ width: `${message.progress || 0}%` }} />
              </div>
            )}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/javascript/common/components/NewMessage/NewMessage.js